export const NameMemberValidation = [
    { required: true, message: 'Name is required' },

    { max: 50, message: 'Name must have maximum of 30 letters' },
    { min: 2, message: 'Name must have minimum of 2 letters' },
];

export const NameValidation = [
    { required: true, message: 'Name is required' },
    { max: 50, message: 'Name must have maximum of 30 letters' },
    { min: 2, message: 'Name must have minimum of 2 letters' },
];

export const TypeValidation = [
    { required: true, message: 'Type is required' },
];

export const DurationValidation = [
    { required: true, message: 'Duration is required' },
];

export const PublishDateValidation = [
    {
        validator: async (_, publishDate) => {
            if (publishDate) {
                if (publishDate.year() > new Date().getFullYear()) {
                    return Promise.reject(
                        "Year mustn't be greater than current year"
                    );
                }
            }
        }
    },
    { required: true, message: 'Publish Date is required' },
];

export const EndDateValidation = [
    { required: true, message: 'End Date is required' },
];

export const CompanyValidation = [
    { required: true, message: 'Company is required' },
];

export const BudgetValidation = [
    { required: true, message: 'Budget is required' },
];

export const DescriptionValidation = [
    { required: true, message: 'Description is required' },
];